import { useState, useContext } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { gql, useQuery } from "@apollo/client"
import _ from "lodash"

import ROUTES from "../../Routes/routesContants"

// PR
import { Dropdown } from "primereact/dropdown"

// Context
import { UserContext } from "../../../context/userContext"

// Comps
import { LoaderMedium } from "../../Loaders"
import ParticipantMenu from "./ParticipantMenu"
import styles from "../../../styles/ParticipantSelector.module.css"
const GET_PARTICIPANTS = gql`
  query ParticipantsSidebar(
    $staff_id: ID!
    $organization_id: ID!
    $searchType: String
  ) {
    participants: getAllActiveParticipants(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: $searchType
    ) {
      participant_id
      participant_membership_status
      participant_name_first
      participant_name_last
    }
  }
`

export default function ParticipantSelector() {
  const [currentParticipant, setCurrentParticipant] = useState(null)
  const [participantList, setParticipantList] = useState(null)

  const userCtx = useContext(UserContext)
  const location = useLocation()

  const navigate = useNavigate()

  const handleSearchType = () => {
    const currentPath = location.pathname
    switch (currentPath) {
      case "/participant/list":
        return "all_participants"
      case "/my-participants":
        return "my_participants"
      default:
        return null
    }
  }

  const participantFromCtx = userCtx.current_participant_id || null

  const { loading } = useQuery(GET_PARTICIPANTS, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      searchType: handleSearchType(),
    },
    skip: !userCtx,
    fetchPolicy: "network-only",
    onCompleted: ({ participants }) => {
      const newParticipantList = _.map(participants, (participant) => {
        const { participant_name_first, participant_name_last } = participant
        const fullName = `${_.unescape(participant_name_first)} ${_.unescape(
          participant_name_last
        )}`
        return {
          participant_id: participant.participant_id,
          name: fullName,
        }
      })
      if (!_.isEmpty(participantFromCtx)) {
        const current = _.find(newParticipantList, {
          participant_id: participantFromCtx,
        })
        current && setCurrentParticipant(current)
      }
      return setParticipantList(newParticipantList)
    },
    onError: (error) => console.error("Error on GET_PARTICIPANTS", error),
  })

  const handleSelectParticipant = async (e) => {
    if (_.isEmpty(e.value)) {
      setCurrentParticipant(null)
      await userCtx.clearParticipant()
      return navigate(ROUTES.PARTICIPANT_MYPARTICIPANTS)
    }
    const { participant_id } = e.value
    await userCtx.changeParticipant(participant_id)
    setCurrentParticipant(e.value)
    return navigate(ROUTES.PARTICIPANT_PROFILE)
  }

  if (loading) return <LoaderMedium />

  return (
    <div className={styles["wrapper"]}>
      <div>
        <Dropdown
          disabled={userCtx.globalLoading}
          value={currentParticipant}
          options={participantList}
          onChange={handleSelectParticipant}
          showClear
          optionLabel="name"
          filter
          filterBy="name"
          placeholder="Select a Participant"
          style={{ marginBottom: 10 }}
        />
      </div>
      <ParticipantMenu />
    </div>
  )
}
